'use client';

import { useCookies } from 'react-cookie';
import { ReactNode, createContext, useContext, useMemo } from 'react';
import { ACTIVE_EXPERIMENTS_COOKIE } from './constants';
import { parseActiveExperiments } from './parse';
import { ExperimentsContextValue } from './types';
const ExperimentsContext = createContext<ExperimentsContextValue | undefined>(undefined);
export function ExperimentsProvider({
  children
}: {
  children: ReactNode;
}) {
  const [cookies] = useCookies([ACTIVE_EXPERIMENTS_COOKIE]);
  const raw = cookies[ACTIVE_EXPERIMENTS_COOKIE];
  const experiments = useMemo(() => parseActiveExperiments(raw), [raw]);
  return <ExperimentsContext.Provider value={{
    experiments
  }} data-sentry-element="unknown" data-sentry-component="ExperimentsProvider" data-sentry-source-file="experiments-provider.tsx">{children}</ExperimentsContext.Provider>;
}
export const useActiveExperiments = () => {
  const context = useContext(ExperimentsContext);
  if (!context) {
    throw new Error('useActiveExperiments must be used within a ExperimentsProvider');
  }
  return context.experiments || [];
};
export const useExperimentVersion = (experimentTitle: string): string | undefined => {
  const experiments = useActiveExperiments();
  return experiments.find(exp => exp.title === experimentTitle)?.version;
};